﻿import React, { useState, useEffect } from 'react';
import { Document } from '../models/document';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { ParsedMsCoa } from '../models/CoaParsing/parsed-ms-coa';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import HtmlEditor from 'devextreme-react/html-editor';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { SelectBox } from 'devextreme-react/select-box';
import { CheckBox } from 'devextreme-react/check-box';
import { Button } from 'devextreme-react/button';
import { LookupItem } from '../models/lookup-item';

//temp
const editorText = `
<h2>COA Data</h2>
<br />
<table>
    <tr>
        <td style="font-weight: bold">Name:</td>
        <td>The file name</td>
    </tr>
    <tr>
        <td style="font-weight: bold">Lot#:</td>
        <td>LRAD0668</td>
    </tr>

</table>

<div style="font-weight: bold">Some bold text</div>
<div>more...</div>
`;


export default function CoaParserForm() {
    const [coaData, setCoaData] =
        useState<ParsedMsCoa>();

    const [includeImages, setIncludeImages] =
        useState([]);

    // const [coaDataString, setCoaDataString] =
    //   useState<string>();

    const [technologies, setTechnologies] =
        useState<LookupItem[]>();

    const [imageTypes, setImageTypes] =
        useState<LookupItem[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, []);

    return (
        <div className="pw-form-container">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">COA Parsing</div>
                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <div>
                        <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                            hint="go back" className="title-bar-button"
                            height={'2.6em'}
                            onClick={goBack} />
                    </div>

                </div>
            </div>

            <div className="pw-comp-row">
                <div>
                    <Button className="title-bar-button"
                        text="Load COA File" icon="search" type="success"
                        onClick={fileLoaderClick} />
                </div>
                <div>
                    <Button className="title-bar-button"
                        text="Save to Database" icon="save" type="success"
                        onClick={saveCoaDataToDatabase} />
                </div>
            </div>

            <div id="NoteViewerContainer" className="pw-form-section">
                <HtmlEditor height={coaData && coaData.coaDataHtmlString ? "100%" : "20rem"} readOnly={true}
                    value={coaData && coaData.coaDataHtmlString ? coaData.coaDataHtmlString : editorText} />
            </div>

            <div>
                <div>
                    {coaData && coaData.images && coaData.images.length > 0 && coaData.images.map((image) =>
                        <div className="pw-comp-row" key={`image_${image.imageId}`}>
                            <div className="coaImageCapturePreview"
                                key={image && image.imageId && image.imageId.toString()}>
                                <div id={image && image.imageId}
                                    onClick={selectedImageChanged}
                                    className="documentThumb" >
                                    <img alt="thumb"
                                        className="imageThumb"
                                        src={`data:image/png;base64, ${image.base64Blob}`} />
                                    <div id="imageThumbText" className="documentThumbText">No Name</div>
                                </div>
                            </div>
                            <div className="pw-stacked-components pw-margin-top-1">
                                <div className="pw-form-unit pw-comp-15 pw-margin-bottom-05">
                                    <CheckBox text="include" elementAttr={{ id: 'cb_' + image.imageId }}
                                        onValueChanged={onIncludeImageValueChanged} />
                                </div>
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Technology</div>
                                    <SelectBox className="selectbox"
                                        placeholder='NA' elementAttr={{id: 't_' + image.imageId}}
                                        displayExpr='name' valueExpr='id'
                                        dataSource={technologies ? technologies : []}
                                        onValueChanged={onTechnologySelectionChanged}
                                         />
                                </div>
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Image Types</div>
                                    <SelectBox className="selectbox"
                                        elementAttr={{ id: 'it_' + image.imageId }}
                                        placeholder='NA'
                                        displayExpr='name' valueExpr='id'
                                        dataSource={imageTypes ? imageTypes : []}
                                        onValueChanged={onImageTypeSelectionChanged}
                                         />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

            <input type="file"
                id="fileInputElement"
                accept=".pdf"
                className="file-picker-input"
                value=""
                onChange={onFileLoaderChange} />

        </div>
    );

    function onIncludeImageValueChanged(e: any) {
        console.log("onIncludeImageValueChanged:");
        console.log(e);

        //remove the 'cb_':
        //e.element.id
        // value is e.value (true or false)

        if (e.element && e.element.id) {
            const imageId = e.element.id.substring(3);

            console.log("imageId: " + imageId);

            var editedIncludeImages = [...includeImages];

            const matchingIncludedImageIdx = editedIncludeImages.findIndex(i => i.imageId === imageId);

            //if checkbox = TRUE and image is not in included list, add it:
            if (e.value && matchingIncludedImageIdx === -1) {
                editedIncludeImages.push({
                    imageId: imageId,
                    technology: null,
                    imageType: null
                });
            }

            if (!e.value && matchingIncludedImageIdx > -1) {
                /*
                editedIncludeImages.({
                    id: imageId,
                    technology: null,
                    imageType: null
                });
                */

            }

            setIncludeImages(editedIncludeImages);
        }
    }

    function onTechnologySelectionChanged(e: any) {
        console.log("onTechnologySelectionChanged:");
        console.log(e);

        //remove the 't_'
        //e.element.id

        //value is e.g. 600 - the id of the tech selected

        if (e.element && e.element.id) {
            const imageId = e.element.id.substring(2);

            console.log("imageId: " + imageId);

            var editedIncludeImages = [...includeImages];

            const matchingIncludedImage = editedIncludeImages.find(i => i.imageId === imageId);

            if (matchingIncludedImage) {
                matchingIncludedImage.technology = e.value;

                setIncludeImages(editedIncludeImages);
            }
        }
    }

    function onImageTypeSelectionChanged(e: any) {
        console.log("onImageTypeSelectionChanged:");
        console.log(e);

        //remove the 'it_'
        //e.element.id
        //value is e.g. 102 - the id of the image type selected


        if (e.element && e.element.id) {
            const imageId = e.element.id.substring(3);

            console.log("imageId: " + imageId);

            var editedIncludeImages = [...includeImages];

            const matchingIncludedImage = editedIncludeImages.find(i => i.imageId === imageId);

            if (matchingIncludedImage) {
                matchingIncludedImage.imageType = e.value;

                setIncludeImages(editedIncludeImages);
            }
        }
    }

    function selectedImageChanged(e: any) {

        console.log("selectedImageChanged:");
        console.log(e);



    }


    function fileLoaderClick(e: any) {
        const fileElem = document.getElementById("fileInputElement") as HTMLInputElement;

        if (fileElem)
            fileElem.click();
    }

    async function parseCoaFile(doc: any) {
        console.log("parseCoaFile::");
        console.log(doc);

        await CrudFunctions.postData("externaldata/parsemscoa", doc)
            .then((data) => {
                console.log("returned COA data");
                console.log(data);

                setCoaData(data);


                //if (data.coaDataHtmlString)
                //  setCoaDataString(data.coaDataHtmlString);

            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating ");
            })

        /*
        {
                "name": "PHR1254_LRAD3703.pdf",
            "kbSize": 474566,
            "mimeTypeString": "application/pdf",
            "base64Blob": "JVBERi0x..."
        }
            */

    }

    async function saveCoaDataToDatabase() {
        if (!coaData)
            return;

        console.log("includeImages:");
        console.log(includeImages);

        console.log("coaData:");
        console.log(coaData);

            /*
        await CrudFunctions.postData("coaparsing/coa", coaData)
            .then((data) => {
                console.log("returned COA data");
                console.log(data);

                // if (data.coaDataHtmlString)
                //   setCoaDataString(data.coaDataHtmlString);

            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating ");
            });
            */
    }

    function getAllData() {

        //temp
        let bsTypes: LookupItem[] = [
            { id: 600, name: "GC" },
            { id: 800, name: "HPLC" }
        ];

        setTechnologies(bsTypes);

        let iTypes: LookupItem[] = [
            { id: 100, name: "ImpurityChromatogram" },
            { id: 101, name: "AssayChromatogram" },
            { id: 102, name: "AssayChromatogramMS" },
            { id: 103, name: "AssayChromatogramUsp" },
            { id: 104, name: "AssayChromatogramEp" },
            { id: 105, name: "AssayChromatogramBp" }
        ];

        setImageTypes(iTypes);
    }

    async function onFileLoaderChange(e: any) {
        let files = e.target.files;

        if (files && files.length > 0) {
            let file = files[0];

            let doc: Document = {
                name: file.name,
                kbSize: file.size,
                mimeTypeString: file.type
            };

            var reader = new FileReader();

            reader.onload = (event: any) => readFile(doc, event)
                .then((doc) => {
                    parseCoaFile(doc);
                });

            reader.readAsBinaryString(file);
        }
    }

    async function readFile(doc: Document, event: any): Promise<any> {
        if (event && event.target && event.target.result) {
            let binaryString = event.target.result;
            let documentData = btoa(binaryString);

            doc.base64Blob = documentData;
            return doc;
        }
    }


    //navigation

    function goBack() {
        history.back();
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}